import * as actionTypes from './actionTypes';
import {
    I_Group,
    I_showSwitcher,
    I_stationInfo,
    I_callInfoJson,
    I_CalendarInfo,
} from './interfaces';
import dayjs from 'dayjs';

const initialState: I_Group = {
    ProductType: '',
    IsB2E: false,
    CreditCardUrl: '',
    CruiseRoomUrl: '',
    GoAirline: '',
    GoDepartureTime: '',
    GoArriveTime: '',
    GoDepartureAirport: '',
    GoArriveAirport: '',
    GoTransferCount: 1,
    BackAirline: '',
    BackDepartureTime: '',
    BackArriveTime: '',
    BackDepartureAirport: '',
    BackArriveAirport: '',
    BackTransferCount: 0,
    TourIndex: 0,
    CheckCruiseInfo: false,
    TelType: 0,
    IsNoFlight: false,
    IsPreview: false,
    IsEnsureGroup: false,
    GroupInfo: {
        TourID: '',
        TourName: '',
        NormGroupID: '',
        NormGroup: '',
        NormGroupImg: '',
        TourDays: 0,
        GoDate: '',
        BackDate: '',
        IsSleepless: false,
        Status: 0,
        StatusUrl: '',
        TotalSeats: 0,
        QuotaSeats: 0,
        SpareSeats: 0,
        IsBooked: false,
        IsEnsureGroup: false,
        IsForeign: false,
        TravelType: 0,
        ThemeID: [],
        AgeCalculation: '',
        StraightLowestPrice: 0,
        IndustryLowestPrice: 0,
        EnterLowestprise: 0,
        IsVip: false,
        VipOrigPrice: 0,
        ArriveID: '',
        MutiGroup: false,
        TourSource: '',
        TourBuName: '',
        KKSeats: 0,
        RegisteredSeats: 0,
        KeepSeats: 0,
        OBSeats: 0,
        GroupID: '',
        ActualSeats: 0,
        WaitSeats: 0,
        LevelID: 0,
        TagList: [],
        TripTypeList: [],
        Price: '',
        OrigPrice: '',
        StartFromCityList: [],
        Country: '',
        CurrencyCode: '',
        SellStartDate: '',
    },
    todayMore: {
        GroupList: [],
    },
    FlightInfo: {
        GroupList: [],
    },
    currentTourID: '',
    scheduleActive: 0,
    isLoading: true,
    isLoadingTours: true,
    FestivalDates: {},
};

const initialSwitcher: I_showSwitcher = {
    isContactTelOpen: false,
    abroadDepOpen: false,
    nextStepLoading: false,
    isAnchorShow: false,
    isCalendarShowM: false,
    isSearchPanelFixed: false,
    findNearGroup: false,
};

const initialCalendarInfo: I_CalendarInfo = {
    CalendarGroups: {
        isListMode: false,
        isLoadingCalendar: true,
        isGuaranteedDisabled: false,
        isGuaranteedChecked: false,
        parmIsEnsureGroup: false,
        month: dayjs().format('YYYY-MM'),
        groups: [],
    },
    chooseDateM: '',
};

const initialStationInfo: I_stationInfo = {
    GroupID: '',
    StationInfoList: [],
    TourID: '',
    TraceId: '',
};

const initialCallInfoJson: I_callInfoJson = {
    calljson: {
        Data: [],
        Token: '',
        TokenExpires: '',
        TraceId: '',
        rCode: '',
        rDesc: '',
        isCompleted: false,
    },
};

const groupReducer = (state: I_Group = initialState, action: any): I_Group => {
    switch (action.type) {
        case actionTypes.SET_GROUP:
            return { ...state, ...action.GroupInfo };
        case actionTypes.SET_PRICESINFO_SUCCESS:
            return { ...state, PricesInfo: action.payload };
        case actionTypes.SET_TODAYMORE_SUCCESS:
            return { ...state, todayMore: action.payload };
        case actionTypes.SET_GROUPALLTOURS:
            return {
                ...state,
                isLoadingTours: true,
            };
        case actionTypes.SET_GROUPALLTOURS_SUCCESS:
            return {
                ...state,
                Schedules: action.payload,
                isLoadingTours: false,
            };
        case actionTypes.SET_GROUPDETAIL_SYNC:
        case actionTypes.SET_GROUPDETAIL_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_STATIONINFO_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_SKI_SUCCESS:
            return { ...state, Ski: action.payload };
        case actionTypes.SET_FLIGHTINFO_SUCCESS:
            return { ...state, FlightInfo: action.payload };
        case actionTypes.SET_CURRENTTOURID:
            return { ...state, currentTourID: action.payload };
        case actionTypes.SET_SCHEDULESACTIVE:
            return { ...state, scheduleActive: action.payload };
        default:
            return state;
    }
};

export const calendarInfoReducer = (
    state: I_CalendarInfo = initialCalendarInfo,
    action: any
): I_CalendarInfo => {
    switch (action.type) {
        case actionTypes.SET_ALLGROUP:
            return {
                ...state,
                CalendarGroups: { ...state.CalendarGroups, groups: action.allGroup },
            };
        case actionTypes.SET_GROUPALLCALENDAR:
            return {
                ...state,
                CalendarGroups: { ...state.CalendarGroups, isLoadingCalendar: true },
            };
        case actionTypes.SET_GROUPALLCALENDAR_SUCCESS:
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    groups: action.payload,
                    isLoadingCalendar: false,
                },
            };
        case actionTypes.SET_CALENDARGROUPS_MODE: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isListMode: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_MONTH: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    month: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_GUARANTEED: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isGuaranteedDisabled: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_GUARANTEEDCHECKED: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isGuaranteedChecked: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_PARMISENSUREGROUP: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    parmIsEnsureGroup: action.payload,
                },
            };
        }
        case actionTypes.SET_CHOOSEDATEM:
            return { ...state, chooseDateM: action.payload };
        default:
            return state;
    }
};

export const switcherReducer = (
    state: I_showSwitcher = initialSwitcher,
    action: any
): I_showSwitcher => {
    switch (action.type) {
        case actionTypes.SET_CONTACTTELOPEN:
            return { ...state, isContactTelOpen: action.payload };
        case actionTypes.SET_ABOARDDEPOPEN:
            return { ...state, abroadDepOpen: action.payload };
        case actionTypes.SET_NEXTSTEPLOADING:
            return { ...state, nextStepLoading: action.payload };
        case actionTypes.SET_ISANCHORSHOW:
            return { ...state, isAnchorShow: action.payload };
        case actionTypes.SET_ISCALENDARSHOWM:
            return { ...state, isCalendarShowM: action.payload };
        case actionTypes.SET_ISSEARCHPANELFIXED:
            return { ...state, isSearchPanelFixed: action.payload };
        case actionTypes.SET_FINDNEARGROUP:
            return { ...state, findNearGroup: action.payload };
        default:
            return state;
    }
};

export const stationInfoReducer = (
    state: I_stationInfo = initialStationInfo,
    action: any
): I_stationInfo => {
    switch (action.type) {
        case actionTypes.SET_STATIONINFO_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const callInfoReducer = (
    state: I_callInfoJson = initialCallInfoJson,
    action: any
): I_callInfoJson => {
    switch (action.type) {
        case actionTypes.SET_CALLJSON_SUCCESS:
            return { ...state, calljson: action.payload };
        default:
            return state;
    }
};

export default groupReducer;
